
import { v2Host } from '@/config/host';

export default {
  name: 'async-config',
  data: function data() {
    return {};
  },

  computed: {
    configUrl: {
      get: function get() {
        return v2Host + '/admin/component';
      }
    }
  },
  methods: {}
};